const BACKEND_URL = process.env.NODE_ENV === "production"
  ? (process.env.REACT_APP_BACKEND_URL || "")
  : (process.env.REACT_APP_BACKEND_URL || "http://localhost:5001");
const API_URL = BACKEND_URL ? `${BACKEND_URL}/api` : "/api";
const UPLOAD_API_BASE = BACKEND_URL ? BACKEND_URL : "";

const toFormValue = (value) =>
  typeof value === "string" ? value : JSON.stringify(value);

const appendIfDefined = (formData, key, value) => {
  if (value === undefined || value === null || value === "") {
    return;
  }

  formData.append(key, toFormValue(value));
};

const parseJsonResponse = async (response) => {
  const payload = await response.json().catch(() => null);

  if (!response.ok || payload?.success === false) {
    throw new Error(payload?.message || payload?.error || "Request failed");
  }

  if (!payload) {
    throw new Error("Empty server response");
  }

  return payload.product ?? payload.products ?? payload.file ?? payload.files ?? payload;
};

const requestWithProgress = (options) =>
  new Promise((resolve, reject) => {
    const request = new XMLHttpRequest();

    request.open(options.method, options.url, true);
    request.withCredentials = true;

    request.upload.onprogress = (event) => {
      if (!event.lengthComputable || !options.onProgress) {
        return;
      }
      options.onProgress((event.loaded / event.total) * 100);
    };

    request.onload = () => {
      const payload = request.response;
      let parsed = null;
      try {
        parsed = JSON.parse(payload);
      } catch {}

      if (request.status >= 200 && request.status < 300) {
        resolve(parsed?.product ?? parsed?.products ?? parsed?.file ?? parsed?.files ?? parsed);
      } else {
        reject(
          new Error(
            parsed?.message || parsed?.error || `Upload failed with status ${request.status}`
          )
        );
      }
    };

    request.onerror = () => {
      reject(new Error("Network error during file upload"));
    };

    request.send(options.body);
  });

export const loadProducts = async () => {
  const response = await fetch(API_URL + "/products");
  return parseJsonResponse(response);
};

export const createProduct = async (payload) => {
  const response = await fetch(API_URL + "/products", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
  return parseJsonResponse(response);
};

export const updateProduct = async (id, payload) => {
  const response = await fetch(`${API_URL}/products/${id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });
  return parseJsonResponse(response);
};

export const deleteProduct = async (id) => {
  const response = await fetch(`${API_URL}/products/${id}`, {
    method: "DELETE",
  });
  await parseJsonResponse(response);
};

export const uploadImage = async (file, onProgress) => {
  const body = new FormData();
  body.append("image", file);

  return requestWithProgress({
    url: UPLOAD_API_BASE + "/api/upload/image",
    method: "POST",
    body,
    onProgress,
  });
};

export const uploadVideo = async (file, onProgress) => {
  const body = new FormData();
  body.append("video", file);

  return requestWithProgress({
    url: UPLOAD_API_BASE + "/api/upload/video",
    method: "POST",
    body,
    onProgress,
  });
};

export const uploadImages = async (files, onProgress) => {
  const body = new FormData();
  for (let i = 0; i < files.length; i++) {
    body.append("images", files[i]);
  }

  return requestWithProgress({
    url: UPLOAD_API_BASE + "/api/upload/images",
    method: "POST",
    body,
    onProgress,
  });
};
